import * as types from './constants';

const initialState = {
  data: {},
  loading: false,
  errors_api: {}
};

const actions = {
  // Delete Regularusers Group
  [types.DELETE_REGULARUSERS_GROUP_REQUEST]: state => {
    const data = {
      ...state,
      loading: true
    };

    return { ...data };
  },

  [types.DELETE_REGULARUSERS_GROUP_DONE]: (state, { payload }) => {
    const data = {
      ...state,
      data: payload,
      loading: false
    };

    return { ...data };
  },

  [types.DELETE_REGULARUSERS_GROUP_FAILED]: (state, { payload }) => {
    const data = {
      ...state,
      loading: false,
      errors_api: payload
    };

    return { ...data };
  }
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};